module.exports = __webpack_public_path__ + "static/media/arrow-orange.a3844a8c.svg";